import events from './events';
import { integrations, integrationsToDisplayName } from './integrations';

import type { TrackingOptions } from '$lib/types/TrackingOptions';

const options: { [event: string]: TrackingOptions } = {
    /**
     *
     * @type {{sequential : boolean, passThrough : {}, tracking : {perspective : boolean, integrations : boolean}, middlewares: {}}}
     */
    [events.formEvent]: {
        sequential: false,
        passThrough: {
            integrations: {
                [integrationsToDisplayName[integrations.facebookPixel]]: false,
            },
        },
        tracking: {
            perspective: false,
            integrations: true,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.interactionFormEvent]: {
        sequential: true,
        passThrough: {},
        tracking: {
            perspective: true,
            integrations: false,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.interactionQuestionEvent]: {
        sequential: true,
        passThrough: {},
        tracking: {
            perspective: true,
            integrations: false,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.interactionQuestionMultipleChoiceEvent]: {
        sequential: true,
        passThrough: {},
        tracking: {
            perspective: true,
            integrations: false,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.answerEvent]: {
        sequential: false,
        passThrough: {},
        tracking: {
            perspective: false,
            integrations: true,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.metaEvent]: {
        sequential: true,
        passThrough: {},
        tracking: {
            perspective: true,
            integrations: false,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.buttonEvent]: {
        sequential: false,
        passThrough: {},
        tracking: {
            perspective: false,
            integrations: true,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
    [events.facebookPageViewEvent]: {
        sequential: false,
        passThrough: {},
        tracking: {
            perspective: false,
            integrations: true,
        },
        middlewares: {
            [integrationsToDisplayName[integrations.adwords]]: null,
            [integrationsToDisplayName[integrations.facebookPixel]]: null,
            [integrationsToDisplayName[integrations.googleAnalytics]]: null,
            [integrationsToDisplayName[integrations.googleTagManager]]: null,
            [integrationsToDisplayName[integrations.hubspot]]: null,
            [integrationsToDisplayName[integrations.linkedin]]: null,
            [integrationsToDisplayName[integrations.hotjar]]: null,
        },
    },
};

export default options;
